'use strict';

(function () {
  function syncAnnouncementHeight() {
    var bar = document.querySelector('.section-announcement-bar');
    document.documentElement.style.setProperty(
      '--announcement-height',
      (bar ? bar.offsetHeight : 0) + 'px'
    );
  }

  window.addEventListener('resize', syncAnnouncementHeight);
  syncAnnouncementHeight();

  function gotoSearch(query) {
    var trimmed = (query || '').trim();
    if (!trimmed) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'search?q=' + encodeURIComponent(trimmed) + '&type=product';
  }

  document.addEventListener('mousedown', function (event) {
    if (!event.target.closest || !event.target.closest('.drawer-search__input--close')) return;
    event.preventDefault();
    if (typeof window.closeSearchDrawer === 'function') window.closeSearchDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    var input = event.target.closest && event.target.closest('#drawer-search-input');
    if (!input) return;

    event.preventDefault();
    gotoSearch(input.value);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('#searchbox.drawer-search__form');
    if (!form) return;

    event.preventDefault();
    var input = form.querySelector('#drawer-search-input');
    gotoSearch(input ? input.value : '');
  });
})();
